import { CmsApiPersonaQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiPersonaQuizBlock';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpPersonaQuizBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiPersonaQuizBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      data={{
        ...data,
        // @ts-expect-error TODO fix me
        text: data.questions[0].title,
        image: data.questions[0].image,
        buttonText: getText('View Quiz'),
      }}
      blockId={blockId}
    />
  );
}
